// audio_controller.js

class AudioController {
  constructor() {
    this.players = new Set();
    this.currentPlayer = null;
  }

  register(player) {
    this.players.add(player);
  }

  unregister(player) {
    this.players.delete(player);
  }

  play(player) {
    if (this.currentPlayer && this.currentPlayer !== player) {
      this.currentPlayer.pause();
    }
    this.currentPlayer = player;
  }

  stopAll() {
    this.players.forEach(player => player.pause());
    this.currentPlayer = null;
  }
}

export default new AudioController();